function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLight = function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.935
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m10.021 19.934-2.974-2.886h-4.1v-4.1L-.001 10l2.952-2.952v-4.1h4.1L10.021 0l2.93 2.952h4.1v4.1L19.999 10l-2.952 2.952v4.1h-4.1zm0-4.207a5.484 5.484 0 0 0 4.042-1.674 5.565 5.565 0 0 0 1.663-4.075 5.678 5.678 0 0 0-5.7-5.7 5.565 5.565 0 0 0-4.08 1.658 5.484 5.484 0 0 0-1.674 4.042 5.716 5.716 0 0 0 5.749 5.749zm0-1.322a4.4 4.4 0 0 1-4.427-4.427 4.209 4.209 0 0 1 1.288-3.106 4.29 4.29 0 0 1 3.139-1.278 4.362 4.362 0 0 1 4.383 4.383 4.29 4.29 0 0 1-1.278 3.139 4.209 4.209 0 0 1-3.105 1.289zm0 3.678 2.378-2.356h3.326V12.4l2.4-2.4-2.4-2.4V4.273h-3.326l-2.379-2.4-2.421 2.4H4.272V7.6l-2.4 2.4 2.4 2.4v3.326h3.3zm-.022-8.105z",
    style: {
      fill: "currentColor"
    }
  }));
};

export default SvgLight;